import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async freeze(data) {
        try
        {            
            const response = await axios.post(`Cutoff/freeze`,
            {
                item:data
            },
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })   
            return response
        }
        catch (error)
        {
            console.log('Cutoff freeze api error')
            throw error
        }
    },
    async undofreeze(data) {
        try
        {            
            const response = await axios.post(`Cutoff/undofreeze`,
            {
                item:data
            },
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('Cutoff undofreeze api error')
            throw error
        }
    },
    async close(data) {
        try
        {            
            const response = await axios.post(`Cutoff/close`,
            {
                item:data
            },
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('Cutoff close api error')
            throw error
        }
    },
    async undoclose(data) {
        try
        {            
            const response = await axios.post(`Cutoff/undoclose`,
            {
                item:data
            },
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })        
            return response
        }
        catch (error)
        {
            console.log('Cutoff undoclose api error')
            throw error
        }
    },
    async getByCompany() {
        try
        {            
            const response = await axios.get(`Cutoff/bycompany`)            
            return response
        }
        catch (error)
        {
            console.log('Cutoff getByCompany api error')
            throw error
        }
    },
    async getByUser() {
        try
        {            
            const response = await axios.get(`Cutoff/byuser`)            
            return response
        }
        catch (error)
        {
            console.log('Cutoff getByCompany api error')
            throw error
        }
    },
    //not used
    // async getByTransDate(transDate) {
    //     try
    //     {            
    //         const response = await axios.get(`Cutoff/transdate/${transDate}`)            
    //         return response
    //     }
    //     catch (error)
    //     {
    //         console.log('Cutoff getByTransDate api error')
    //         throw error
    //     }
    // },
    async getById(cutoffId) {
        try
        {            
            const response = await axios.get(`Cutoff/${cutoffId}`)            
            return response
        }
        catch (error)
        {
            console.log('Cutoff getById api error')
            throw error
        }
    },
    async getAudit(cutoffId) {
        try
        {            
            const response = await axios.get(`Cutoff/${cutoffId}/audit`)            
            return response
        }
        catch (error)
        {
            console.log('Cutoff getById api error')
            throw error
        }
    },
    async sendReminder(data) {
        try
        {            
            const response = await axios.post(`Cutoff/reminder`, {item: data})            
            return response
        }
        catch (error)
        {
            console.log('Cutoff sendReminder api error')
            throw error
        }
    },
    async getSettings() {
        try
        {            
            const response = await axios.get(`Cutoff/settings`,
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('Cutoff getSettings api error')
            throw error
        }
    },
    async getTypes() {
        try
        {            
            const response = await axios.get(`Cutoff/types`,
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('Cutoff getTypes api error')
            throw error
        }
    },
    async updateSettings(data) {
        try
        {            
            const response = await axios.post(`Cutoff/settings`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('Cutoff updateSettings api error')
            throw error
        }
    },
    async generateCurrent() {
        try
        {            
            const response = await axios.post(`Cutoff/generate_current`,
            {
                headers: {
                    'page_key': pageKeys.cutoff //cutoff settings
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Cutoff generateCurrent api error')
            throw error
        }
    }
}